module.exports = __webpack_public_path__ + "assets/Husten.208c9b49.png";